module.exports = __webpack_public_path__ + "img/vip-logo-middle.496eb3d0.svg";